import React, { PureComponent } from 'react';
import Breadcrumb, { BreadcrumbItem } from './Breadcrumb';
import { getUser, getAgency } from '../api/users';
import Tabs from './Tabs';
import EditUser from '../routes/Users/Tabs/Edit';
import ChangeUserPassword from '../routes/Users/Tabs/Password';
import ChangeAgencyPassword from '../routes/Agencies/Tabs/Password';
import EditAgencies from '../routes/Agencies/Tabs/Edit';
import Loader from '../atoms/Loader';
import MarketingTab from '../routes/Users/Tabs/Marketing';
import TourLeader from '../routes/Users/Tabs/TourLeader';
import { USER_TABS, AGENCY_TABS } from '../utils/constants';

export default class EditContainer extends PureComponent {
  state = {
    loading: true,
    openSavingModal: false,
    error: null,
    user: null,
    agency: null,
    id: '',
    isMarketingTabVisible: false,
    isTourLeaderVisible: false,
    tab: 'User',
  }

  getTabUrl = (tab) => {
    this.setState({ tab });
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    const isAgencyRoute = this.props.location.pathname.includes('/agenzie/');

    try {
      if (isAgencyRoute) {
        const agencyData = await getAgency(id);
        this.setState({
          agency: agencyData,
          id,
          tab: 'Agency',
        });
      } else {
        const userData = await getUser(id);
        this.setState({
          user: userData,
          id,
          isMarketingTabVisible: userData.ruoli.includes('marketing'),
          isTourLeaderVisible: userData.ruoli.includes('tourleader'),
        });
      }
    } catch (e) {
    } finally {
      this.setState({ loading: false });
    }
  }

  checkRole = async () => {
    const { id } = this.props.match.params;
    const isAgencyRoute = this.props.location.pathname.includes('/agenzie/');

    this.setState({ loading: true });

    if (isAgencyRoute) {
      const agency = await getAgency(id);
      this.setState({ agency });
    } else {
      const user = await getUser(id);
      this.setState({
        user,
        isMarketingTabVisible: user.ruoli.includes('marketing'),
        isTourLeaderVisible: user.ruoli.includes('tourleader'),
      });
    }

    this.setState({ loading: false });
  }

  render() {
    const {
      user, agency, isMarketingTabVisible, isTourLeaderVisible, id, tab, loading,
    } = this.state;
    const isAgencyRoute = this.props.location.pathname.includes('/agenzie/');

    if (loading) return <Loader />;

    if (isAgencyRoute && agency) {
      const tabs = AGENCY_TABS.map(({ label }) => label);
      return (
        <>
          <Breadcrumb>
            <BreadcrumbItem to="/admin/agenzie">Agenzie</BreadcrumbItem>
            <BreadcrumbItem to={`/admin/agenzie/${id}`}>
              {agency.nome || 'new'}
            </BreadcrumbItem>
          </Breadcrumb>

          <Tabs tabs={tabs} id={id} getTabUrl={this.getTabUrl} role={agency.ruoli} />
          {tab === 'Agency' && <EditAgencies id={id} agency={agency} checkRole={this.checkRole} {...this.props} />}
          {tab === 'Password' && <ChangeAgencyPassword id={id} agency={agency} />}
        </>
      );
    }

    if (!isAgencyRoute && user) {
      let tabs = USER_TABS.map(({ label }) => label);
      if (!isMarketingTabVisible) tabs = tabs.filter((t) => t !== 'Marketing');
      if (!isTourLeaderVisible) tabs = tabs.filter((t) => t !== 'TourLeader');

      return (
        <>
          <Breadcrumb>
            <BreadcrumbItem to="/admin/users">Utenti</BreadcrumbItem>
            <BreadcrumbItem to={`/admin/users/${id}`}>
              {user.nome || 'new'}
            </BreadcrumbItem>
          </Breadcrumb>

          <Tabs tabs={tabs} id={id} getTabUrl={this.getTabUrl} role={user.ruoli} />
          {tab === 'User' && <EditUser id={id} user={user} checkRole={this.checkRole} {...this.props} />}
          {tab === 'Password' && <ChangeUserPassword id={id} user={user} />}
          {tab === 'Marketing' && <MarketingTab id={id} user={user} />}
          {tab === 'TourLeader' && <TourLeader id={id} user={user} />}
        </>
      );
    }

    return <Loader />;
  }
}
